import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Box,
  Hidden,
  Grid,
  TextField,
  MenuItem,
  Button,
  TableSortLabel,
  Dialog,
  DialogContent,
  DialogActions,
  useTheme,
} from "@mui/material";
import GridOnIcon from "@mui/icons-material/GridOn";
import openFile from "../shared/functions/download";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import { useSessionStorage } from "../../utils/hooks";
// import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import FormularGenehmigen from "../FormularGenehmigen";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";

function AbsenceLog(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [log, setLog] = useState([]);
  const [zeitraum, setZeitraum] = useState([]);
  const [aktionen, setAktionen] = useState([]);
  const [betroffen, setBetroffen] = useState([]);
  const [typen, setTypen] = useState([]);
  const [zrIndex, setZrIndex] = useState(0);
  const [akIndex, setAkIndex] = useState(0);
  const [beIndex, setBeIndex] = useState(0);
  const [typIndex, setTypIndex] = useState(0);
  const { accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, hideMessage } = useMessage();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("antragsdatum");
  const [filterBy, setFilterBy] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [formularKey, setFormularKey] = useState();
  const theme = useTheme();
  var isDarkMode = false;
  if (theme.palette.mode === "light") {
    isDarkMode = false;
  } else {
    isDarkMode = true;
  }

  // Alle Storage bezogenen teile gehören zu einer Entwicklung in welcher wir die Filter im local Storage wegspeichern was jetzt derzeit jedoch
  // nicht notwendig war aber in Zukunft notwendig werden kann!
  // const [storage, setStorage] = useSessionStorage(LOCAL_STORAGE_KEY.meldungenProt);
  const [topPosition, setTopPosition] = useState(65);

  useEffect(() => {
    const scroller = document.getElementById("ectool-scroll-container");
    const target = scroller || window;
    const handleScroll = () => {
      const position = scroller ? scroller.scrollTop : window.scrollY;
      if (position >= 1186) {
        setTopPosition(0);
      } else {
        setTopPosition(65);
      }
    };

    target.addEventListener("scroll", handleScroll);

    return () => {
      target.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ladeLog = () => {
    var tmpzr = "nan";
    var tmpbe = "nan";
    var tmpak = "nan";

    // if (storage) {
    //   const tmpStorageDat = JSON?.parse(storage);
    //   tmpzr = tmpStorageDat?.zrKey;
    //   tmpak = tmpStorageDat?.akKey;
    //   tmpbe = tmpStorageDat?.beKey;
    // }

    setIsLoading(true);
    const payload = {
      mandant: client,
      statement: "PROTO_LADEN",
      program: "PMURA3",
      zeitraum: tmpzr,
      betroffen: tmpbe,
      aktionen: tmpak,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, logCb);
  };

  useEffect(() => {
    ladeLog();
    // if (storage) {
    //   const tmpStorageDat = JSON?.parse(storage);
    //   setZrIndex(tmpStorageDat?.zrIndex);
    //   setAkIndex(tmpStorageDat?.akIndex);
    //   setBeIndex(tmpStorageDat?.beIndex);
    //   // setTypIndex(tmpStorageDat?.typIndex);
    // }

    // eslint-disable-next-line
  }, []);

  // const setStorageCallback = useCallback(
  //   (indices) => {
  //     setStorage(JSON.stringify(indices));
  //   },
  //   [setStorage]
  // );

  // useEffect(() => {
  //   setStorageCallback({
  //     zrKey: zeitraum[zrIndex]?.key,
  //     zrIndex: zrIndex,
  //     akKey: aktionen[akIndex]?.key,
  //     akIndex: akIndex,
  //     beKey: betroffen[beIndex]?.key,
  //     beIndex: beIndex,
  //     typIndex: typIndex,
  //     typKey: typen[typIndex]?.typ,
  //   });
  // }, [zrIndex, akIndex, beIndex, typIndex]);

  // useEffect(() => {
  //   if (storage && typen) {
  //     const tmpStorageDat = JSON?.parse(storage);
  //     const found = typen?.some((item) => item?.typ === tmpStorageDat?.typKey);
  //     if (found == true) {
  //       setFilterBy(tmpStorageDat.typIndex);
  //       setTypIndex(tmpStorageDat?.typIndex);
  //     }
  //   }
  // }, [typen]);

  const logCb = (response) => {
    if (response.status === 200) {
      setZeitraum(response.data.zeitraum);
      setAktionen(response.data.aktionen);
      setBetroffen(response.data.betroffen);
      setTypen(response.data.typen);

      if (response.data.antraege) {
        setLog(response.data.antraege);
      } else {
        setLog([]);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
        setIsLoading(false);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
        setIsLoading(false);
      }
    }
  };

  const setRedirect = (path) => {
    navigate(path);
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  function Change(art, value) {
    setIsLoading(true);
    setFilterBy(0);
    setTypIndex(0);
    var tmpzr = zeitraum[zrIndex].key;
    var tmpbe = betroffen[beIndex].key;
    var tmpak = aktionen[akIndex].key;
    if (art === "zeitraum") tmpzr = zeitraum[value].key;
    if (art === "betroffen") tmpbe = betroffen[value].key;
    if (art === "aktionen") tmpak = aktionen[value].key;

    const payload = {
      mandant: client,
      statement: "PROTO_CHANGE",
      program: "PMURA3",
      zeitraum: tmpzr,
      betroffen: tmpbe,
      aktionen: tmpak,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, logCb, setRedirect);
  }

  const filter = () => {
    return (
      <Grid container justifyContent="center" spacing={1}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            id="zeitraum"
            label={t("Zeitraum")}
            select
            fullWidth
            value={zrIndex}
            onChange={(e) => {
              Change("zeitraum", e.target.value);
              setZrIndex(e.target.value);
            }}
            variant="outlined"
          >
            {zeitraum &&
              zeitraum.map((item, index) => (
                <MenuItem key={index} value={index}>
                  {item.bez}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
        {/* <Grid item xs={12} sm={6} md={3}>
          <TextField
            id="betroffen"
            label={t("Personen")}
            select
            fullWidth
            value={beIndex}
            onChange={(e) => {
              Change("betroffen", e.target.value);
              setBeIndex(e.target.value);
            }}
            variant="outlined"
          >
            {betroffen &&
              betroffen.map((item, index) => (
                <MenuItem key={index} value={index}>
                  {item.bez}
                </MenuItem>
              ))}
          </TextField>
        </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            id="aktionen"
            label={t("Aktionen")}
            select
            fullWidth
            value={akIndex}
            onChange={(e) => {
              Change("aktionen", e.target.value);
              setAkIndex(e.target.value);
            }}
            variant="outlined"
          >
            {aktionen &&
              aktionen.map((item, index) => (
                <MenuItem key={index} value={index}>
                  {item.bez}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            id="typ"
            label={t("Typ")}
            select
            fullWidth
            value={typIndex}
            onChange={(e) => {
              setFilterBy(e.target.value);
              setTypIndex(e.target.value);
            }}
            variant="outlined"
          >
            {typen &&
              typen.map((item, index) => (
                <MenuItem key={index} value={index}>
                  {item.typ}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
      </Grid>
    );
  };

  function InExcel() {
    setIsLoading(true);
    const date = new Date();
    const formattedDate = date
      .toISOString()
      .replace(/[^0-9]/g, "")
      .slice(0, 14);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "EXCEL",
      log: log,
      name: `Protokoll_export_${formattedDate}.xlsx`,
      zeitraum: zeitraum[zrIndex].bez,
      betroffen: betroffen[beIndex].bez,
      aktionen: aktionen[akIndex].bez,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        const fileName = `Protokoll_export_${formattedDate}.xlsx`;
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
    setIsLoading(false);
  }

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  //Hiermit das Datum in ein Verwendbares Format wandeln für Date Operator
  const parseDate = (dateStr, time) => {
    const [day, month, year] = dateStr.split(".");
    if (time) {
      return new Date(`${year}-${month}-${day}T${time}`);
    } else {
      return new Date(`${year}-${month}-${day}`);
    }
  };

  const detailsClick = (element) => {
    setFormularKey(element.dbkey);
    setShowForm(true);
  };

  // Funktion zum Sortieren der Listen Daten
  const sortData = (array) => {
    return array.sort((a, b) => {
      if (orderBy === "antragsdatum") {
        const dateA = parseDate(a.datum, a.zeit);
        const dateB = parseDate(b.datum, b.zeit);
        if (order === "asc") {
          return dateA.getTime() - dateB.getTime();
        } else {
          return dateB.getTime() - dateA.getTime();
        }
      }

      if (orderBy === "typ") {
        const typA = a.art.toLowerCase();
        const typB = b.art.toLowerCase();

        if (order === "asc") {
          if (typA < typB) return -1;
          if (typA > typB) return 1;
          return 0;
        } else {
          if (typA < typB) return 1;
          if (typA > typB) return -1;
          return 0;
        }
      }

      if (orderBy === "betroffen") {
        const typA = a.mitarbeiter.toLowerCase();
        const typB = b.mitarbeiter.toLowerCase();

        if (order === "asc") {
          if (typA < typB) return -1;
          if (typA > typB) return 1;
          return 0;
        } else {
          if (typA < typB) return 1;
          if (typA > typB) return -1;
          return 0;
        }
      }

      if (orderBy === "vorgesetzter") {
        const typA = a.vorgesetzter.toLowerCase();
        const typB = b.vorgesetzter.toLowerCase();

        if (order === "asc") {
          if (typA < typB) return -1;
          if (typA > typB) return 1;
          return 0;
        } else {
          if (typA < typB) return 1;
          if (typA > typB) return -1;
          return 0;
        }
      }

      if (orderBy === "antragszeitraum") {
        const dateA = parseDate(a.zeitraum.slice(0, 10));
        const dateB = parseDate(b.zeitraum.slice(0, 10));
        if (order === "asc") {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      }

      if (orderBy === "aktion") {
        const typA = a.aktion.toLowerCase();
        const typB = b.aktion.toLowerCase();

        if (order === "asc") {
          if (typA < typB) return -1;
          if (typA > typB) return 1;
          return 0;
        } else {
          if (typA < typB) return 1;
          if (typA > typB) return -1;
          return 0;
        }
      }

      return 0;
    });
  };

  const filterData = (array) => {
    return array.filter((item) => {
      const searchTerm = ";" + typen[filterBy]?.typ.toLowerCase() + ";";
      const tmpItem = ";" + item.art + ";";

      if (searchTerm == ";alle anzeigen;") return item.art;
      return tmpItem.toLowerCase().includes(searchTerm);
    });
  };

  const sortedLog = filterData(sortData([...log]));

  const dataRequest =
    sortedLog.length > 0 ? (
      sortedLog.map((element, index) => {
        return (
          <TableRow key={index}>
            <Hidden smDown>
              <TableCell>
                {console.log(element)}
                {element.datum} - {element.zeit}
                {element.dbkey && (
                  <Button
                    onClick={() => {
                      detailsClick(element);
                    }}
                  >
                    <VisibilityIcon></VisibilityIcon>
                  </Button>
                )}
              </TableCell>
              <TableCell>{element.art}</TableCell>
              <TableCell>{element.mitarbeiter}</TableCell>
              <TableCell>{element.vorgesetzter}</TableCell>
              <TableCell>{element.zeitraum}</TableCell>
              <TableCell>{element.aktion}</TableCell>
              <TableCell>{element.bemerkung}</TableCell>
            </Hidden>
            <Hidden smUp>
              <TableCell>
                {element.datum} - {element.zeit}
                {element.dbkey && (
                  <Button
                    onClick={() => {
                      detailsClick(element);
                    }}
                  >
                    <VisibilityIcon></VisibilityIcon>
                  </Button>
                )}
                <br />
                {element.art}
                <br />
                {element.mitarbeiter}
                <br />
                {element.vorgesetzter}
                <br />
                {element.zeitraum}
                <br />
                {element.aktion}
                <br />
                {element.bemerkung}
                <br />
              </TableCell>
            </Hidden>
          </TableRow>
        );
      })
    ) : (
      <TableRow>
        <Hidden smDown>
          <TableCell colSpan={7}>
            <Typography variant="body1">{t("Es wurden keine abgeschlossenen Anträge gefunden")}</Typography>
          </TableCell>
        </Hidden>
        <Hidden smUp>
          <TableCell>
            <Typography variant="body1">{t("Es wurden keine abgeschlossenen Anträge gefunden")}</Typography>
          </TableCell>
        </Hidden>
      </TableRow>
    );

  return (
    <Page>
      {/* Desktop */}
      <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
        <Fragment>
          <Box p={2}>{filter()}</Box>
          <Box p={2} sx={{ flexGrow: 1, overflowY: "hidden" }}>
            <Dialog open={showForm} onClose={() => setShowForm(false)} maxWidth="xl" fullWidth>
              <DialogContent>
                <FormularGenehmigen client={client} accessToken={accessToken} formularKeyProps={formularKey}></FormularGenehmigen>
              </DialogContent>
              <DialogActions>
                <Button
                  style={{ marginRight: "10px" }}
                  color="primary"
                  variant="contained"
                  display="flex"
                  onClick={() => {
                    setShowForm(false);
                  }}
                >
                  {t("Schließen")}
                </Button>
              </DialogActions>
            </Dialog>

            <TableContainer sx={{ maxHeight: window.innerHeight - 350 }} component={Paper}>
              <Table stickyHeader>
                <Hidden smDown>
                  <TableHead>
                    <TableRow>
                      <TableCell padding={"normal"} sortDirection={orderBy === "antragsdatum" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "antragsdatum"}
                          direction={orderBy === "antragsdatum" ? order : "asc"}
                          onClick={() => handleRequestSort("antragsdatum")}
                        >
                          {t("Antragsdatum")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "typ" ? order : false}>
                        <TableSortLabel active={orderBy === "typ"} direction={orderBy === "typ" ? order : "asc"} onClick={() => handleRequestSort("typ")}>
                          {t("Typ")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "betroffen" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "betroffen"}
                          direction={orderBy === "betroffen" ? order : "asc"}
                          onClick={() => handleRequestSort("betroffen")}
                        >
                          {t("betroffener Mitarbeiter")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "vorgesetzter" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "vorgesetzter"}
                          direction={orderBy === "vorgesetzter" ? order : "asc"}
                          onClick={() => handleRequestSort("vorgesetzter")}
                        >
                          {t("ausführender Mitarbeiter")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "antragszeitraum" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "antragszeitraum"}
                          direction={orderBy === "antragszeitraum" ? order : "asc"}
                          onClick={() => handleRequestSort("antragszeitraum")}
                        >
                          {t("Antragszeitraum")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "aktion" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "aktion"}
                          direction={orderBy === "aktion" ? order : "asc"}
                          onClick={() => handleRequestSort("aktion")}
                        >
                          {t("Aktion")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell>{t("Bemerkung")}</TableCell>
                    </TableRow>
                  </TableHead>
                </Hidden>
                <TableBody>{dataRequest}</TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box p={2}>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<GridOnIcon />} onClick={InExcel}>
                    {t("In Excel")}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fragment>
      </Box>

      {/* Mobile */}
      <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
        <Fragment>
          <Box p={2}>{filter()}</Box>
          <Box p={2} sx={{ flexGrow: 1, overflowY: "hidden" }}>
            <Dialog open={showForm} onClose={() => setShowForm(false)} maxWidth="xl" fullWidth>
              <DialogContent>
                <FormularGenehmigen client={client} accessToken={accessToken} formularKeyProps={formularKey}></FormularGenehmigen>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "flex-start" }}>
                <Button color="primary" variant="contained" onClick={() => setShowForm(false)}>
                  {t("Schließen")}
                </Button>
              </DialogActions>
            </Dialog>
            <TableContainer sx={{ maxHeight: window.innerHeight - 450 }} component={Paper}>
              <Table stickyHeader>
                <Hidden smDown>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("Antragsdatum")}</TableCell>
                      <TableCell>{t("Typ")}</TableCell>
                      <TableCell>{t("betroffener Mitarbeiter")}</TableCell>
                      <TableCell>{t("ausführender Mitarbeiter")}</TableCell>
                      <TableCell>{t("Antragszeitraum")}</TableCell>
                      <TableCell>{t("Aktion")}</TableCell>
                      <TableCell>{t("Bemerkung")}</TableCell>
                    </TableRow>
                  </TableHead>
                </Hidden>
                <TableBody>{dataRequest}</TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box p={2}>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<GridOnIcon />} onClick={InExcel}>
                    {t("In Excel")}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fragment>
      </Box>
    </Page>
  );

  if (window.cordova) {
    return (
      <div>
        <Fragment>
          <Box p={2}>{filter()}</Box>
          <Box p={2} sx={{ flexGrow: 1, overflowY: "hidden" }}>
            <Dialog open={showForm} onClose={() => setShowForm(false)} maxWidth="xl" fullWidth>
              <DialogContent>
                <FormularGenehmigen client={client} accessToken={accessToken} formularKeyProps={formularKey}></FormularGenehmigen>
              </DialogContent>
              <DialogActions>
                <Button
                  style={{ marginRight: "10px" }}
                  color="primary"
                  variant="contained"
                  display="flex"
                  onClick={() => {
                    setShowForm(false);
                  }}
                >
                  {t("Schließen")}
                </Button>
              </DialogActions>
            </Dialog>
            <TableContainer sx={{ maxHeight: window.innerHeight - 500 }} component={Paper}>
              <Table stickyHeader>
                <Hidden smDown>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("Antragsdatum")}</TableCell>
                      <TableCell>{t("Typ")}</TableCell>
                      <TableCell>{t("betroffener Mitarbeiter")}</TableCell>
                      <TableCell>{t("ausführender Mitarbeiter")}</TableCell>
                      <TableCell>{t("Antragszeitraum")}</TableCell>
                      <TableCell>{t("Aktion")}</TableCell>
                      <TableCell>{t("Bemerkung")}</TableCell>
                    </TableRow>
                  </TableHead>
                </Hidden>
                <TableBody>{dataRequest}</TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box p={2}>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<GridOnIcon />} onClick={InExcel}>
                    {t("In Excel")}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fragment>
      </div>
    );
  } else {
    return (
      <div>
        <Fragment>
          <Box p={2}>{filter()}</Box>
          <Box p={2} sx={{ flexGrow: 1, overflowY: "hidden" }}>
            <Dialog open={showForm} onClose={() => setShowForm(false)} maxWidth="xl" fullWidth>
              <DialogContent>
                <FormularGenehmigen client={client} accessToken={accessToken} formularKeyProps={formularKey}></FormularGenehmigen>
              </DialogContent>
              <DialogActions>
                <Button
                  style={{ marginRight: "10px" }}
                  color="primary"
                  variant="contained"
                  display="flex"
                  onClick={() => {
                    setShowForm(false);
                  }}
                >
                  {t("Schließen")}
                </Button>
              </DialogActions>
            </Dialog>

            <TableContainer sx={{ maxHeight: window.innerHeight - 350 }} component={Paper}>
              <Table stickyHeader>
                <Hidden smDown>
                  <TableHead>
                    <TableRow>
                      <TableCell padding={"normal"} sortDirection={orderBy === "antragsdatum" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "antragsdatum"}
                          direction={orderBy === "antragsdatum" ? order : "asc"}
                          onClick={() => handleRequestSort("antragsdatum")}
                        >
                          {t("Antragsdatum")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "typ" ? order : false}>
                        <TableSortLabel active={orderBy === "typ"} direction={orderBy === "typ" ? order : "asc"} onClick={() => handleRequestSort("typ")}>
                          {t("Typ")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "betroffen" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "betroffen"}
                          direction={orderBy === "betroffen" ? order : "asc"}
                          onClick={() => handleRequestSort("betroffen")}
                        >
                          {t("betroffener Mitarbeiter")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "vorgesetzter" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "vorgesetzter"}
                          direction={orderBy === "vorgesetzter" ? order : "asc"}
                          onClick={() => handleRequestSort("vorgesetzter")}
                        >
                          {t("ausführender Mitarbeiter")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "antragszeitraum" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "antragszeitraum"}
                          direction={orderBy === "antragszeitraum" ? order : "asc"}
                          onClick={() => handleRequestSort("antragszeitraum")}
                        >
                          {t("Antragszeitraum")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell padding={"normal"} sortDirection={orderBy === "aktion" ? order : false}>
                        <TableSortLabel
                          active={orderBy === "aktion"}
                          direction={orderBy === "aktion" ? order : "asc"}
                          onClick={() => handleRequestSort("aktion")}
                        >
                          {t("Aktion")}
                        </TableSortLabel>
                      </TableCell>

                      <TableCell>{t("Bemerkung")}</TableCell>
                    </TableRow>
                  </TableHead>
                </Hidden>
                <TableBody>{dataRequest}</TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box p={2}>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<GridOnIcon />} onClick={InExcel}>
                    {t("In Excel")}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fragment>
      </div>
    );
  }
}
export default AbsenceLog;
